import { useRef, useState } from "react";

const CompanyProductReadOnlyRow = ({ index, t, companyProdListItem, handleDeleteClick, oddIdx, add, setError }) => {
	const [isSubmit, setIsSubmit] = useState(false);

	function submitComplete() {
		setIsSubmit(false);
	}

	function submitDelete(event, companyProdListItem) {
		setError("");
		setIsSubmit(true);
		handleDeleteClick(event, companyProdListItem, submitComplete);
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{companyProdListItem.productGroupName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{companyProdListItem.commodityName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{companyProdListItem.productName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{companyProdListItem.productSku}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{companyProdListItem.description}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{companyProdListItem.status}</td>
			<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block"} onClick={(event) => submitDelete(event, companyProdListItem)}>
					{companyProdListItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
			</td>


		</tr>
	)
}
export default CompanyProductReadOnlyRow;